<template>
  <div class="grid-x flex-grow divide-x order-details-page">
    <div class="cell large-8 cell-block-y order-details-main">
      <Loading :loading="waitPending">
        <div
          class="grid-y divide-y"
          v-if="!!order && !!object">
          <div class="cell p-8">
            <div class="flex items-center justify-between">
              <template v-if="$delve(object, 'family') === true">
                <div class="flex flex-row items-center space-x-6">
                  <div
                    class="w-20 h-20 rounded-full overflow-hidden"
                    v-if="object.photoAttach">
                    <Attachment
                      class="w-full h-full object-cover object-center"
                      :id="object.photoAttach"/>
                  </div>
                  <h2 class="text-2xl font-bold">
                    {{ $delve(object, 'name') }}
                  </h2>
                </div>
              </template>
              <template v-else>
                <h2 class="text-2xl font-bold">
                  {{ $delve(order, 'subject.burials.0.person.name') }}
                </h2>
                <div class="flex flex-row items-center space-x-2">
                  <span class="text-14px leading-17px">Даты жизни:</span>
                  <span class="badge badge-zircon text-inverse text-14px leading-17px font-rubik">
                  {{ $delve(order, 'subject.burials.0.person.birthday') | date }}
                  -
                  {{ $delve(order, 'subject.burials.0.person.deathday') | date }} г.
                </span>
                </div>
              </template>
            </div>
          </div>
          <div class="cell p-8 flex flex-col space-y-6 order-details-order-block">
            <div class="flex flex-row items-center justify-between space-x-4 order-details-status-row">
              <div class="flex flex-row items-center space-x-4">
                <StatusBadge class="badge-lg font-bold" :status="$delve(order, 'state')"/>
                <span
                  class="badge badge-lg font-bold bg-primary"
                  v-if="order.priority">
                Приоритетный
              </span>
                <span
                  class="badge badge-lg font-bold bg-zircon text-inverse"
                  v-if="order.isComplex">
                Комплексный
              </span>
              </div>
              <div class="flex-grow flex flex-row items-center space-x-4 order-details-utility-actions">
                <div class="flex-grow" v-if="countdown">
                  <span class="text-14px leading-22px">
                    {{ countdown.label }}:
                    <Countdown class="text-14px leading-22px" :time="countdown.diff">
                      <template slot-scope="props">
                        <b class="font-rubik font-medium">
                          {{ props.totalMilliseconds | duration }}
                        </b>
                      </template>
                    </Countdown>
                  </span>
                </div>
                <div>
                  <div
                    class="text-primary text-sm leading-4 underline font-bold cursor-pointer"
                    @click="onOrderReturnClick"
                  >
                    Вернуть в эфир
                  </div>
                </div>
                <div
                  v-if="order && order.timer"
                  class="flex flex-col space-y-1">
                  <div
                    class="text-danger text-sm leading-4 underline font-bold cursor-pointer"
                    @click="onTimerResetClick('day')"
                  >
                    Добавить 24 часа
                  </div>
                  <div
                    class="text-danger text-sm leading-4 underline font-bold
                  cursor-pointer"
                    @click="onTimerResetClick('week')"
                  >
                    Добавить 1 неделю
                  </div>
                  <div
                    class="text-danger text-sm leading-4 underline font-bold
                  cursor-pointer"
                    @click="onTimerResetClick('month')"
                  >
                    Добавить 1 месяц
                  </div>
                </div>
                <div class="flex flex-col">
                  <div>
                    <div
                      class="text-secondary text-sm leading-4 underline font-bold cursor-pointer"
                      @click="onCopyPaymentLinkClick"
                    >
                      Скопировать ссылку на оплату
                    </div>
                  </div>
                  <div>
                    <div
                      class="text-secondary text-sm leading-4 underline font-bold cursor-pointer"
                      @click="onOrderDownloadLogsClick"
                    >
                      Скачать логи
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="flex flex-row space-x-2"
                v-if="$delve(order, 'rating')">
                <img class="mb-1" src="@/assets/icons/star.svg"/>
                <b class="text-14px leading-16px">
                  {{ $numeral($delve(order, 'rating')).format('0.0') }}
                </b>
              </div>
            </div>
            <div
              class="flex flex-col order-details-service-category"
              v-for="(category, categoryIndex) in order.services"
              :key="categoryIndex">
              <div class="flex flex-row space-x-4">
                <div
                  class="flex-shrink-0 flex-grow-0 w-6 h-6"
                  v-if="$delve(category, 'serviceCategory.iconAttach')">
                  <Attachment
                    class="w-full h-full object-contain object-top"
                    :id="$delve(category, 'serviceCategory.iconAttach')"/>
                </div>
                <div class="flex flex-col space-y-4">
                  <b class="block text-14px leading-16px mt-1">
                    {{ $delve(category, 'serviceCategory.name') }}
                  </b>
                  <ul
                    class="flex flex-col text-12px leading-14px"
                    v-for="(service, serviceIndex) in category.services"
                    :key="serviceIndex">
                    <li>
                      <span>
                        {{ $delve(service, 'service.name') }}:
                      </span>

                      <span class="font-bold text-primary">
                        {{ $numeral(Number($delve(order, 'price'))).format('0,0 $') }}
                      </span>

                      <template v-if="Number($delve(order, 'price')) !== Number($delve(service, 'service.price'))">
                        <span class="text-black">
                          (цена в заказе) ·
                        </span>

                        <span class="font-bold text-primary">
                          {{ $numeral(Number($delve(service, 'service.price'))).format('0,0 $') }}
                        </span>

                        <span class="text-black">
                          (новая актуальная цена по справочнику)
                        </span>
                      </template>
                    </li>
                    <li v-if="$delve(service, 'count') > 1">
                      <span>Итого: </span>
                      <span class="font-bold text-primary">
                      {{ $numeral($delve(service, 'total')).format('0,0 $') }}
                    </span>
                    </li>
                    <li v-if="$delve(service, 'options')">
                      <span>Доп. опции: </span>
                      <span class="font-bold text-primary">
                      {{ $voca.capitalize($delve(service, 'options'), true) }}
                    </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="cell p-8">
            <h3 class="m-0 font-bold">Комментарий к заказу</h3>
            <small class="mt-1">
              {{ $delve(order, 'description') || 'Заказчик не оставил комментарий' }}
            </small>
          </div>
          <ObjectDetails
            :subject="object"
            v-if="object"/>
        </div>
      </Loading>
    </div>
    <div
      class="cell large-4 cell-block-y flex flex-col p-8 order-details-side"
      v-if="order">
      <div class="flex flex-col flex-grow space-y-8 order-details-side-inner">
        <div class="flex items-center space-x-2 justify-between order-details-side-controls">
          <div class="flex items-end space-x-2 order-details-commission">
            <div class="flex flex-col">
              <span>Комиссия сервиса</span>
              <Input classes="bg-hint" placeholder="Комиссия сервиса" type="number" min="0" max="100" v-model="commissionPercent" />
            </div>
            <button
              class="btn btn-sm btn-primary font-normal flex items-center justify-center"
              :style="{ width: '49px', height: '49px', padding: 0 }"
              @click="onCommissionPercentSave">
              <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" fill="white" />
              </svg>
            </button>
          </div>
          <div
            class="flex flex-row items-center"
            v-if="
            order.state !== 'completed' &&
            order.state !== 'closed' &&
            order.state !== 'cancelled' &&
            order.state !== 'dispute'
          ">
            <span
              class="text-danger text-15px leading-4 underline font-bold cursor-pointer"
              v-b-modal="'cancel'">
              Отменить заказ
            </span>
          </div>
        </div>
        <div class="cell flex-grow flex flex-col order-details-chat">
          <Messenger :order="order"/>
        </div>
        <div class="cell flex-shrink-0 flex flex-col space-y-2 order-details-footer-actions">
          <template v-if="order.state === 'dispute'">
            <div class="flex flex-row items-center">
              <button
                class="btn btn-xs btn-danger flex-grow"
                @click="onClose"
                v-if="order.joined">
                  <template v-if="$wait.is(`close.order.${order.id}`)">
                    Спор закрывается...</template>
                  <template v-else>Закрыть спор</template>
                </button>
              <button
                class="btn btn-xs btn-primary flex-grow"
                @click="join()"
                v-else>Присоединиться</button>
            </div>
          </template>
          <template
            v-if="order.state === 'assigned' ||
            order.state === 'in_work' ||
            order.state === 'dispute'">
            <div class="flex flex-row items-center space-x-2">
              <button
                class="btn btn-xs btn-outline-primary flex-grow"
                @click="$router.back()">Назад</button>
              <button
                class="btn btn-xs btn-primary flex-grow"
                v-b-modal="'change-contractor'">Сменить исполнителя</button>
            </div>
          </template>
          <template v-if="
            order.state === 'active' ||
            order.state === 'completed' ||
            order.state === 'closed' ||
            order.state === 'cancelled'
          ">
            <div class="flex flex-row items-center space-x-2">
              <button
                class="btn btn-xs btn-outline-primary flex-grow"
                @click="$router.back()">Назад</button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <OrderCancelModal
      :order="order"
      @submit="onCancel"
    />
    <OrderCancelModal
      id="close-dispute"
      :order="order"
      purpose="close-dispute"
      @submit="onCloseDisputeSubmit"
    />
    <ChangeContractorModal
      @submit="onChangeContractor"/>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import Countdown from '@chenfengyuan/vue-countdown';
import StatusBadge from '@/components/StatusBadge.vue';
import ObjectDetails from '@/components/ObjectDetails.vue';
import Attachment from '@/components/global/Attachment.vue';
import Messenger from '@/components/Messenger.vue';
import OrderCancelModal from '@/components/Order/OrderCancelModal.vue';
import ChangeContractorModal from '@/components/Order/ChangeContractorModal.vue';
import Loading from '@/components/Loading.vue';
import {
  orderDownloadLogs,
  orderPaymentLink,
  orderResetTimer,
  orderReturn,
  orderUpdateCommissionPercent,
} from '@/api/orders';
import { SET_ORDER } from '@/store/modules/orders/mutation-types';
import Input from '@/components/Input.vue';

export default {
  components: {
    Input,
    ObjectDetails,
    StatusBadge,
    Countdown,
    Messenger,
    OrderCancelModal,
    Attachment,
    ChangeContractorModal,
    Loading,
  },
  data() {
    return {
      now: this.$moment(),
      commissionPercent: undefined,
    };
  },
  computed: {
    ...mapGetters({
      orders: 'orders/order',
      objects: 'objects/object',
      serviceCategoryGetter: 'services/category',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    waitKey() {
      return `fetch.order.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
    order() {
      const order = this.orders(this.id);
      if (!order || !this.serviceCategoryGetter()) {
        return null;
      }
      return {
        ...order,
        services: _(order.services)
          .groupBy((obj) => _.get(obj, 'service.category.id'))
          .transform((result, value, key) => {
            const serviceCategory = this.serviceCategoryGetter(parseInt(key, 10)) || {};
            // eslint-disable-next-line no-param-reassign
            result.push({
              serviceCategory,
              services: value.map((serviceObj) => ({
                ...serviceObj,
                service: {
                  ...serviceObj.service,
                  price: parseFloat(serviceObj.service.price),
                },
                // eslint-disable-next-line arrow-body-style
                options: serviceObj.options.map((option) => {
                  const categoryService = _.find(
                    serviceCategory.services,
                    (categoryServiceObj) => categoryServiceObj.id === serviceObj.service.id,
                  ) || {};
                  const categoryServiceOption = _.find(
                    categoryService.options,
                    (optionObj) => optionObj.id === option,
                  );
                  return _.get(categoryServiceOption, 'name');
                }).filter((option) => typeof option !== 'undefined' && option !== null).join(', '),
                total: serviceObj.count * parseFloat(_.get(serviceObj, 'service.price')),
              })),
            });
          }, [])
          .value(),
      };
    },
    object() {
      if (this.order) {
        const id = _.get(this.order, 'subject.id');
        if (id) {
          return this.objects(id);
        }
        return _.get(this.order, 'subject');
      }
      return null;
    },
    countdown() {
      const data = _.get(this.order, 'timer');
      if (data) {
        const diff = this.$moment(data.expiresAt, 'YYYY-MM-DD HH:mm:ss').diff(this.$moment());
        if (diff > 0) {
          const { name } = data;
          let label = '';
          switch (name) {
            case 'free_cancel':
              label = 'Время до бесплатной отмены заказа';
              break;
            case 'start_work':
              label = 'Время до начала работ';
              break;
            case 'complete':
              label = 'Время до завершения работ';
              break;
            case 'close':
              label = 'Время до завершения заказа';
              break;
            case 'dispute':
              label = 'Время до окончания спора';
              break;
            default:
          }
          return {
            label,
            diff,
          };
        }
      }
      return null;
    },
  },
  filters: {
    date(s) {
      const date = moment(s);
      if (date.isValid()) {
        // eslint-disable-next-line no-underscore-dangle
        let { _f } = date;
        if (_f) {
          _f = _f.split('-').reverse().join('.');
          return date.format(_f);
        }
      }
      return null;
    },
    duration(s) {
      const duration = moment.duration(s, 'milliseconds');
      if (duration.isValid()) {
        return duration.format('HH:mm:ss');
      }
      return null;
    },
  },
  methods: {
    ...mapActions({
      fetch: 'orders/ACT_FETCH_ORDER',
      joinOrder: 'orders/ACT_JOIN_ORDER',
      cancel: 'orders/ACT_CANCEL_ORDER',
      assign: 'orders/ACT_ORDER_ASSIGN',
      close: 'orders/ACT_ORDER_CLOSE',
      fetchMessages: 'orders/ACT_FETCH_MESSAGES',
    }),
    join() {
      if (this.id) {
        this.joinOrder(this.id);
      }
    },
    onCancel(event) {
      this.cancel({
        id: this.id,
        payload: event,
      }).then(() => {
        this.$bvModal.show('cancelled');
      });
    },
    onChangeContractor(event) {
      if (!event) return null;
      return this.assign({
        id: this.id,
        contractor: event,
      }).then(() => {
        this.$bvModal.show('changed-contractor');
      });
    },
    onClose() {
      this.$bvModal.show('close-dispute');
    },
    onCloseDisputeSubmit(e) {
      this.close({
        id: this.id,
        payload: e,
      }).then(() => {
        this.$bvModal.hide('close-dispute');
      });
    },
    getAllMessages() {
      this.fetchMessages({
        id: this.order.id,
        withWho: 'customer',
        referenceId: null,
        withRef: false,
      }).then(() => {});
      this.fetchMessages({
        id: this.order.id,
        withWho: 'contractors',
        referenceId: null,
        withRef: false,
      }).then(() => {});
    },
    async onTimerResetClick(entity) {
      try {
        const days = (() => {
          switch (entity) {
            case 'week':
              return 7;
            case 'month':
              return Math.abs(this.$moment().diff(this.$moment().add(1, 'month'), 'days'));
            default:
              return 1;
          }
        })();
        const response = await orderResetTimer(this.order.id, days);
        const order = response.data;
        const firstService = _.head(_.get(order, 'services') || []);
        const abbreviation = _.get(order, 'displayCategory.abbreviation')
          || _.get(firstService, 'service.category.abbreviation');
        this.$store.commit(`orders/${SET_ORDER}`, {
          ...order,
          name: `${abbreviation}-${order.id}`,
        });
        this.$iwalyNotify.success({
          text: 'Таймер успешно сброшен!',
        });
      } catch (e) {
        console.error(e);
      }
    },
    async onOrderReturnClick() {
      const response = await orderReturn(this.order.id);
      if (response && response.data) {
        this.$store.commit(`orders/${SET_ORDER}`, response.data);
        this.$iwalyNotify.success({
          text: 'Заказ успешно возвращен в эфир',
        });
      }
    },
    async onOrderDownloadLogsClick() {
      const response = await orderDownloadLogs(this.order.id);
      const logs = response?.data?.data;
      if (logs && logs.length > 0) {
        const headers = Object.keys(logs[0]);
        const csvContent = [
          headers.join(','),
          ...logs.map((row) => headers.map((header) => row[header]).join(',')),
        ].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `order-${this.order.id}-logs.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async onCopyPaymentLinkClick() {
      try {
        const response = await orderPaymentLink(this.order.id);
        const url = decodeURIComponent(response?.data?.url);
        await navigator.clipboard.writeText(decodeURIComponent(url));
        this.$iwalyNotify.success({
          text: 'Ссылка скопирована',
        });
      } catch (e) {
        console.error(e);
      }
    },
    async onCommissionPercentSave() {
      const emptyCommission = this.commissionPercent === ''
        || this.commissionPercent === null
        || typeof this.commissionPercent === 'undefined';
      const commissionPercent = emptyCommission ? null : Number(this.commissionPercent);

      if (commissionPercent !== null
        && (!Number.isFinite(commissionPercent) || commissionPercent < 0 || commissionPercent > 100)) {
        return;
      }

      try {
        await orderUpdateCommissionPercent(this.order.id, {
          commissionPercent: commissionPercent === null ? null : +(commissionPercent).toFixed(2),
        });
        this.$iwalyNotify.success({
          text: commissionPercent === null
            ? 'Индивидуальная комиссия снята. Используется стандартная комиссия.'
            : 'Комиссия сервиса для заказа успешно изменена!',
        });
        await this.fetch(this.id);
      } catch (e) {
        const message = e?.response?.data?.errors?.commissionPercent?.[0]
          || 'Не удалось изменить комиссию заказа.';
        this.$iwalyNotify.error({ text: message });
      }
    },
  },
  watch: {
    $route: {
      handler() {
        this.fetch(this.id);
      },
      deep: true,
      immediate: true,
    },
    order: {
      handler(e) {
        if (e) {
          this.commissionPercent = e.commissionPercent;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$eventBus.$on('new.chat.message', ({ id }) => {
      if (parseInt(id, 10) === parseInt(this.id, 10)) {
        this.fetchMessages({
          id: this.order.id,
          withWho: 'customer',
          referenceId: null,
          withRef: false,
        }).then(() => {});
        this.fetchMessages({
          id: this.order.id,
          withWho: 'contractors',
          referenceId: null,
          withRef: false,
        }).then(() => {});
      }
    });
    window.addEventListener('focus', this.getAllMessages);
  },
  beforeDestroy() {
    this.$eventBus.$off('new.chat.message');
    window.removeEventListener('focus', this.getAllMessages);
  },
};
</script>
